import Head from 'next/head';
import React, { useCallback, useEffect, useState } from 'react';
import getMetaTagData from '../../../src/common/services/getMetaTagData';

import Axios from "axios";
import cookieCutter from 'cookie-cutter';
import utils, { getLnbList } from "../../../src/common/utils/passUtil";
import Loading from '../../../src/component/pc/common/Loading';
import CouponBox from "../../../src/component/pc/pass/coupon/CouponBox";
import ServiceNotice from "../../../src/component/pc/pass/ServiceNotice";
import { toFit } from '../../../src/hooks/useToFit';

function Coupon({ metaTagData, couponData, loginJwt }) {
  const [login_jwt, setLogin_jwt] = useState(loginJwt); // props에서 받은 loginJwt로 초기화
  const [platform, setPlatform] = useState();
  const [tabType, setTabType] = useState('hold');
  const [couponHoldCount, setCouponHoldCount] = useState('0');
  const [couponExpireCount, setCouponExpireCount] = useState('0');
  const [pageQueryParams, setPageQueryParams] = useState({ offset: 1, limit: 6 });
  const [couponDataList, setCouponDataList] = useState([]);
  const [couponDataIsLoading, setCouponDataIsLoading] = useState(false);
  const { getCouponHoldList, getCouponExpireList } = utils;

  const fetchCouponData = useCallback(async () => {
    if (!login_jwt) return;

    const listUrl = tabType === 'hold'
      ? process.env.NEXT_PUBLIC_API_PASS_HOLD_LIST
      : process.env.NEXT_PUBLIC_API_PASS_EXPIRE_LIST;

    const param = `?jwtToken=${login_jwt}&PageNo=${pageQueryParams.offset}&PageSize=${pageQueryParams.limit}`;
    const url = `${listUrl}${param}`;

    setCouponDataIsLoading(true);

    try {
      const response = await Axios.get(url, { timeout: 3000 });
      const addList = response.data.List || [];
      
      const totalCount = response.data.totalcnt || 0;
      if (tabType === 'hold') setCouponHoldCount(totalCount);
      else setCouponExpireCount(totalCount);

      if (pageQueryParams.offset === 1) {
        setCouponDataList(addList);
      } else {
        setCouponDataList(prev => [...prev, ...addList]);
      }
    } catch (error) {
      console.error('Error fetching coupon data:', error);
    } finally {
      setCouponDataIsLoading(false);
    }
  }, [login_jwt, pageQueryParams.offset, pageQueryParams.limit, tabType]);

  useEffect(() => {
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');
    setPlatform(platformCookie);
  }, []);

  useEffect(() => {
    if (login_jwt) {
      getCouponExpireList(login_jwt, '1').then(res => {
        if (res.retval == '0') {
          setCouponExpireCount(res.totalcnt);
        }
      });
    }
  }, [login_jwt]);

  useEffect(() => {
    const handleScroll = toFit(() => {

      if (window.innerHeight + Math.ceil(window.pageYOffset) >= document.body.offsetHeight) {
        setPageQueryParams(prev => {
          const nextOffset = prev.offset + 1;
          setCouponDataList(sPrev => {
            return sPrev;
          });

          if (prev.offset + 1 === nextOffset) {
            prev.offset = nextOffset;
            return { ...prev };
          } else {
            return prev;
          }
        });
      }
    }, {});

    window.document.addEventListener('scroll', handleScroll);

    return () => {
      window.document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    fetchCouponData();
  }, [fetchCouponData]);

  const tabClickHandler = (type) => {
    if (type !== tabType) {
      setTabType(type);
      setPageQueryParams({ offset: 1, limit: 6 });
    }
  };

  return (
    <>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_PC_PASSMONEY_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
        <script src='//developers.kakao.com/sdk/js/kakao.min.js' />
        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents" style={{ minHeight: '100vh' }}>
        <div className="passmoneyContents">
          {getLnbList('pc')}
          <div className="passmoneyCont_coupon">
            <div className="curationBannerWrap" style={{ backgroundColor: '#1678FF' }}>
              <img src="/images/pass/couponBnr02.png" className="curationBanner" alt="고객님의 보유 쿠폰을 확인하세요! 다양한 할인 혜택을 받으세요!" />
            </div>
            <div className="tabListWrap_coupon">
              <a href="#none" className={`tabBtn ${tabType === 'hold' ? 'current' : ''}`} onClick={() => tabClickHandler('hold')}>보유쿠폰 <strong className="text_number">{couponHoldCount}</strong></a>
              <a href="#none" className={`tabBtn ${tabType === 'expire' ? 'current' : ''}`} onClick={() => tabClickHandler('expire')}>사용완료쿠폰 <strong className="text_number">{couponExpireCount}</strong></a>
            </div>
            {couponDataList.length > 0 ?
              <ul className='couponList_w'>
                {couponDataList.map((item, index) => (
                  <li key={index} className='couponList_cont'>
                    <CouponBox view {...item} tabType={tabType} />
                  </li>
                ))}
              </ul>
              :
              <div className="noCoupon_w">
                <strong className="noCoupon_text">사용 가능한 쿠폰이 없습니다.</strong>
                <span className="iconSvg_coupon"></span>
              </div>}

            {couponDataIsLoading && <Loading />}

            <div className="noticeList_wrap">
              {couponData.service_notice && (<ServiceNotice data={couponData.service_notice} />)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const getCouponData = async () => {
  let result = null;

  try {
    const couponData = await Axios.get(process.env.NEXT_PUBLIC_API_COUPON_KO, { timeout: 3000 });
    result = couponData.data ? { ...couponData.data } : null;
  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

export async function getServerSideProps(ctx) {
  const { cookies } = ctx.req;
  const { LOGIN_JWT = null } = cookies;
  const { JOIN_PLATFORM } = cookies;
  const { pageSection, pageCategory } = ctx.query;

  let metaTagData;
  let couponData;

  try {
    metaTagData = getMetaTagData(ctx.req.url, 'coupon', pageCategory);
    couponData = await getCouponData();
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      loginJwt: LOGIN_JWT,
      couponData: couponData,
      metaTagData
    }
  };
}

export default Coupon;
